import * as React from "react";

export interface RadioGroupContextProps {
  onChange: React.FormEventHandler<HTMLInputElement>;
  value: string;
  disabled?: boolean;
  name?: string;
}

export const RadioGroupContext =
  React.createContext<RadioGroupContextProps | null>(null);

export default RadioGroupContext;
